module.exports = __webpack_public_path__ + "img/ChinaTelecom.10c62377.png";